export default class ReviewTeacherDevelopmentCtrl {
  constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog) {
  // constants
    const reviewTVM = this

    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))
    const user = JSON.parse($cookies.get('currentUser'))
    reviewTVM.teacher = $stateParams.name
    if (!reviewTVM.teacher) {
      reviewTVM.teacher = user.name
    }

    reviewTVM.mainLabel = $state.current.data.displayName
    reviewTVM.courses = []

    const colorClass = [
      'text-gris-dark',
      'text-azul',
      'text-rojo',
      'text-verde'
    ]
    const iconClasses = [
      'mdi-hardware-keyboard-arrow-down',
      'mdi-hardware-keyboard-arrow-up'
    ]

  // variables

    // teacher ID varies depending of view
    let teacherId = $stateParams.teacherId
    if (!teacherId) {
      teacherId = JSON.parse($cookies.get('currentUser')).teacherId
    }

    reviewTVM.iconClass = iconClasses[0]
    reviewTVM.showData = false
    reviewTVM.viewLoaded = true
    reviewTVM.criteriaFilter = ''
    reviewTVM.selectedCourse = null
    reviewTVM.detailsData = null
    reviewTVM.classEye = colorClass[0]
    reviewTVM.approvedHand = colorClass[0]
    reviewTVM.repprovedHand = colorClass[0]
    reviewTVM.selectedWorkplan = {}
    reviewTVM.isLoadingDetails = false
    reviewTVM.details=details

  // methods
    reviewTVM.tagClass = tagClass
    reviewTVM.courseBckgrd = courseBckgrd
    reviewTVM.courseText = courseText
    reviewTVM.toggleChevron = toggleChevron
    reviewTVM.getReviewData = getReviewData
    reviewTVM.close = close

    // data validations
    reviewTVM.thereIsDetails = thereIsDetails


  // services

    activate()

    function activate () {
      return getReviewData()
    }

    function getReviewData () {
      
      WorkPlanSrv.getCoursesIntern.getList().$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            reviewTVM.courses = dataReturn.listCoursesIntern
            // loadData(dataReturn)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(listphd)
        }
      )
    }

    function getCourseDetails (course, reload = false) {
      WorkPlanSrv.getCoursesInternDetail.getList({courseId: course.courseId}).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            reviewTVM.detailsData = dataReturn.listCoursesInternDetail[0]
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )

      if (!reload) {
        reviewTVM.isLoadingDetails = true
        reviewTVM.detailsData = null
      }

      reviewTVM.isLoadingDetails = false;
    }

    function strategicTracing () {
      let newValue = (reviewTVM.detailsData.isStrategicTracing === 1 ? 0 : 1)
      if (newValue === 1) {
        reviewTVM.classEye = colorClass[3]
      } else {
        reviewTVM.classEye = colorClass[0]
      }
      let header = {
        idTeacher: teacherId,
        idActivity: reviewTVM.selectedCourse.workplanTeacherActivityId,
        idEvaluator: user.id,
        idRol: currentRoleId,
        isStrategicTracing: newValue
      }
      WorkPlanSrv.setStrategicTracing.post(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          reviewTVM.detailsData.isStrategicTracing = newValue
        } else {
          if (newValue === 1) {
            reviewTVM.classEye = colorClass[3]
          } else {
            reviewTVM.classEye = colorClass[0]
          }
        }
      })
    }

    function toggleChevron () {
      if (reviewTVM.showData) {
        reviewTVM.iconClass = iconClasses[0]
        reviewTVM.showData = false
      } else {
        reviewTVM.iconClass = iconClasses[1]
        reviewTVM.showData = true
      }
    }

    function thereIsDetails () {
      return reviewTVM.detailsData !== null
    }

    function tagClass (course) {
        return 'azul'
    }

    function courseBckgrd (course) {
      if (reviewTVM.selectedCourse === course) {
        return 'bg-review'
      }
    }

    function courseText (course) {
      if (reviewTVM.selectedCourse === course) {
        return 'text-color-w'
      }
    }

    function details (course) {
      reviewTVM.selectedCourse = course
      getCourseDetails(course)
    }
    
    function thereIsDetails () {
      return reviewTVM.detailsData !== null
    }

    function close(){
      if($state.current.name === 'workplan.teachingJobsReview'){
        return $state.go('workplan.teachingDevelopment')
      }else{
        return $mdDialog.hide()
      }
     
    }
  }
  
}

ReviewTeacherDevelopmentCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/listTeacherJobsView/reviewTeacherDevelopmentCtrl.js